import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { router } from './app/router';
import { PrefsProvider } from './app/prefs';
import { AuthProvider } from './app/auth';
import { ToastProvider } from './components/ui';
import { SessionExpiredModal } from './components/layout/SessionExpiredModal';

// Order matters: fonts and tokens define the variables that base, components
// and layout consume.
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/print.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <PrefsProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
            <SessionExpiredModal />
          </AuthProvider>
        </QueryClientProvider>
      </ToastProvider>
    </PrefsProvider>
  </StrictMode>,
);
